<template>
  <div>
    <cover :pageData="pageData"></cover>
    <div class="page">
      <div
        class="title"
        v-for="(item, index) in tabList"
        :key="index"
        v-show="tabIndex == index"
      >
        <div class="cn_title">{{ item.title }}</div>
        <div class="en_title">{{ item.en_title }}</div>
      </div>
      <div class="body">
        <div class="body_left">
          <div class="tab" v-for="(item, index) in tabList" :key="index">
            <div class="tab_left" @click="changePage(index)">
              <div class="tab_title">{{ item.title }}</div>
              <div class="tab_en_title">{{ item.en_title }}</div>
              <div class="blue_line" v-show="tabIndex == index"></div>
            </div>
            <div class="tab_right">
              <div class="circle">
                <div
                  class="inner_circle"
                  :class="tabIndex == index ? 'blue' : 'gray'"
                ></div>
              </div>
              <div class="line"></div>
            </div>
          </div>
        </div>
        <div class="body_right">
          <!-- 公司简介 -->
          <div class="content0" v-show="tabIndex == 0">
            <!-- <p v-html="msg"></p> -->
            <!-- https://blog.csdn.net/qq_40951289/article/details/106946459?ops_request_misc=%257B%2522request%255Fid%2522%253A%2522169544316016800213075921%2522%252C%2522scm%2522%253A%252220140713.130102334..%2522%257D&request_id=169544316016800213075921&biz_id=0&utm_medium=distribute.pc_search_result.none-task-blog-2~all~top_positive~default-1-106946459-null-null.142^v94^insert_down28v1&utm_term=v-html&spm=1018.2226.3001.4187 -->
            <p class="front" v-html="aboutMeData.details"></p>
            <div class="imgBox">
              <img :src="img_api + aboutMeData.image" alt="" />
            </div>
          </div>
          <!-- 荣誉证书 -->
          <div class="content1" v-show="tabIndex == 1">
            <div class="cer_content" v-for="item in cerSortList" :key="item.id">
              <div class="cer_box">
                <el-image
                  lazy
                  class="cer_box"
                  :src="img_api + item.image"
                  alt=""
                >
                  <div slot="placeholder" class="image-slot">
                    加载中...
                  </div></el-image
                >
              </div>
              <div class="cer_title">{{ item.name }}</div>
            </div>
          </div>
          <!-- <div class="content1" v-show="tabIndex == 1">
            <div class="cer_content" v-for="item in cerLongList" :key="item.id">
              <div class="cer_box">
                <el-image lazy class="cer_box" :src="img_api + item.image" alt="" />
              </div>
              <div class="cer_title">{{ item.name }}</div>
            </div>
          </div> -->
          <!-- 合作伙伴 -->
          <div class="content2" v-show="tabIndex == 2">
            <div class="friends" v-for="item in partners" :key="item.id">
              <div class="friend_box">
                <el-image
                  lazy
                  fit="contain"
                  class="friend_img"
                  :src="img_api + item.image"
                  alt=""
                />
              </div>
            </div>
          </div>
          <!-- 企业宗旨 -->
          <div class="content3" v-show="tabIndex == 3">
            <div class="purpose_title">{{ mission.title }}</div>
            <p class="purpose_des" v-html="mission.details"></p>
          </div>
          <!-- 企业照片 -->
          <div class="content4" v-show="tabIndex == 4">
            <imageBox
              v-for="item in companyPhotos"
              :img="item"
              :key="item.id"
            ></imageBox>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cover from "../components/cover.vue";
import {
  getAboutMeData,
  getPartners,
  gpCompanyMission,
  gpCompanyPhotosForm,
  getCertificate,
} from "@/server/https.js";
import imageBox from "../components/imageBox.vue";
export default {
  name: "About",
  components: {
    cover,
    imageBox,
  },
  data() {
    return {
      pageData: {
        firstTitle: "",
        secondTitle: "",
        bannerImg: "",
        des: "",
      },
      tabList: [
        { title: "公司简介", en_title: "COMPANY PROFILE" },
        { title: "荣誉证书", en_title: "CERTIFICATE" },
        { title: "合作伙伴", en_title: "PARTNER" },
        { title: "企业宗旨", en_title: "ENTERPRISE PURPOSE" },
        { title: "公司风采照", en_title: "COMPANY PHOTO" },
      ],
      tabIndex: 0,

      friends: [],
      partners: [],
      aboutMeData: {},
      mission: {},
      cerSortList: [],
      cerLongList: [],
      companyPhotos: [],
      img_api: "https://www.gdyuanwo.com/gdyuanwo/",
      api: "http://192.168.31.41:7070/gpa/gpwx",
    };
  },
  mounted() {
    var setI = setInterval(() => {
      if (this.$store.state.headList != "") {
        var headList = this.$store.state.headList;
        headList.map((item) => {
          if (item.sort == 1) {
            let Name = item.name;
            this.pageData.firstTitle = Name.slice(0, -2);
            this.pageData.secondTitle = Name.substr(-2);
            this.pageData.bannerImg = item.image;
            this.pageData.des = item.details;
          }
        });
        clearInterval(setI);
      }
    }, 200);
    getAboutMeData().then((res) => {
      this.aboutMeData = res.data.body.contactUs;
    });

    // getCertificate().then((res) => {
    //   this.cerSortList=res.data.body.list;
    // });
  },
  methods: {
    changePage(index) {
      this.tabIndex = index;
      if (index == 1) {
        getCertificate().then((res) => {
          res.data.body.list.sort((a, b) => a.sort - b.sort);
          this.cerSortList = res.data.body.list;
        });

      } else if (index == 2) {
        getPartners().then((res) => {
          this.partners = res.data.body.list;
        });
      } else if (index == 3) {
        gpCompanyMission().then((res) => {
          this.mission = res.data.body.contactUs;
        });
      } else if (index == 4) {
        gpCompanyPhotosForm().then((res) => {
          this.companyPhotos = res.data.body.list;
        });
      }
    },
  },
};
</script>

<style scoped>
.page {
  height: 100%;
  position: relative;
  background: #ffffff;
}

.title {
  display: flex;
  justify-content: center;
}

.cn_title {
  position: absolute;
  font-size: 48px;
  font-weight: bold;
  color: #13489d;
  margin-top: 56px;
  z-index: 2;
}

.en_title {
  position: absolute;
  font-size: 54px;
  font-weight: bold;
  color: #c8d4e1;
  margin-top: 56px;
}

.body_left {
  display: flex;
  flex-direction: column;
  margin-right: 5rem;
}

.tab {
  display: flex;
}

.tab_left {
  display: flex;
  flex-direction: column;
  align-items: end;
  margin-right: 20px;
  width: 300px;
}

.tab_left:hover {
  cursor: pointer;
}

.tab_title {
  float: right;
  font-size: 20px;
  font-weight: 500;
  color: #999999;
}

.tab_en_title {
  float: right;
  font-size: 18px;
  /* width: 200px; */
  font-weight: 500;
  color: #999999;
}

.circle {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #d1d1d1;
}

.inner_circle {
  width: 50%;
  height: 50%;
  border-radius: 50%;
}

.blue_line {
  display: flex;
  flex-direction: column;
  float: right;
  margin-top: 10px;
  width: 48px;
  height: 6px;
  background-color: #13489d;
  transition: all 0.4s;
}

.tab_right {
  display: flex;
}

.line {
  margin-top: 22px;
  margin-left: -12px;
  height: 100px;
  width: 1px;
  background-color: #bfbfbf;
}

.blue {
  transition: all 0.4s;
  background-color: #13489d;
}

.gray {
  transition: all 0.4s;

  background-color: #d1d1d1;
}

.body {
  display: flex;
  margin-top: 200px;
  justify-content: center;
}

.body_right {
  width: 1000px;
}

.front {
  width: 800px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  text-indent: 25px;
  line-height: 2;
}

.imgBox {
  display: flex;
  justify-content: center;
  width: 69.6%;
  /* height: 53.7%; */
  height: 500px;
  margin-bottom: 100px;
  margin-top: 30px;
  margin-left: 50px;
}

/* 荣誉证书 */
.content1 {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
}

.cer_box {
  width: 15rem;
  /* height: 10rem;   */
  /* border: 4px solid rgb(79, 40, 11); */
}
.cer_box_img {
  width: 100%;
}
.cer_content {
  display: flex;
  flex-direction: column;
  margin: 10px;
}

.cer_title {
  display: flex;
  justify-content: center;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  margin-top: 5px;
}

/* 合作伙伴 */
.content2 {
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
}

.friends {
  display: flex;
  margin: 10px;
}

.friend_box {
  width: 199px;
  height: 115px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #d1d1d1;
  /* margin: 10px; */
}

.friend_img {
  width: 100%;
  height: 100%;
}

.purpose_title {
  font-size: 24px;
  font-weight: bold;
  color: #333333;
  margin-bottom: 24px;
}

.purpose_des {
  width: 800px;
  font-size: 16px;
  font-weight: 400;
  color: #333333;
  text-indent: 25px;
  line-height: 2;
}

/* 企业风采照 */
.content4 {
  display: flex;
  /* width: 700px; */
  flex-wrap: wrap;
}

.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 14px;
}
</style>
